export default {
  // Navbar
  'nav.home': '首页',
  'nav.about': '关于我们',
  'nav.solutions': '解决方案',
  'nav.process': '流程',
  'nav.benefits': '优势',
  'nav.contact': '联系我们',
  'nav.getStarted': '开始使用',

  // Hero Section
  'hero.title': '自动化咨询卓越服务',
  'hero.subtitle': '通过智能自动化转型您的运营',
  'hero.description': '我们专注于为医疗保健、教育、零售及服务业提供量身定制的IT解决方案，解决实际运营挑战，实现可衡量的成果。',
  'hero.consultation': '预约咨询',
  'hero.ourSolutions': '我们的解决方案',

  // About Section
  'about.title': '关于我们',
  'about.subtitle': '您值得信赖的自动化合作伙伴',
  'about.description1': 'Global Pillar Limited于2022年在香港成立。多年来，我们积累了深厚的专业和技术知识，为不同行业提供服务。我们专注于通过结构化的发现、设计、开发和测试流程，提供符合客户独特需求的定制IT解决方案。',
  'about.description2': '作为智能手机兴起时期移动应用开发的先驱，我们持续整合先进技术，提升服务质量和效率。我们的综合解决方案使企业能够在维持可负担的IT预算的同时无缝运作。',
  'about.stat1': '已完成项目',
  'about.stat2': '服务行业',
  'about.stat3': '客户满意度',
  'about.stat4': '全天候支持',

  // Solutions Section
  'solutions.title': '我们的解决方案',
  'solutions.subtitle': '针对您行业的专业自动化咨询',
  'solutions.healthcare': '医疗保健',
  'solutions.education': '教育',
  'solutions.retail': '零售与服务',
  'solutions.learnMore': '了解更多',
  'solutions.showLess': '收起',
  'solutions.scheduleConsultation': '预约咨询',

  // Healthcare
  'healthcare.desc': '为医疗机构提供合规、高效的自动化解决方案',
  'healthcare.pain1.title': '分散的患者记录',
  'healthcare.pain1.challenge': '多个系统导致数据孤岛、重复输入和潜在错误',
  'healthcare.pain1.solution': '我们的咨询方法：实施统一的电子健康记录(EHR)系统，整合所有患者数据，实现即时访问和更新',
  'healthcare.pain1.result': '记录检索时间减少70%，数据准确性提高40%',
  'healthcare.pain2.title': '手动预约排程',
  'healthcare.pain2.challenge': '电话预约导致双重预订、长时间等待和行政负担',
  'healthcare.pain2.solution': '我们的咨询方法：部署智能预约系统，具有自动提醒、在线预订和资源优化功能',
  'healthcare.pain2.result': '未到诊率降低60%，行政工作量减少50%',
  'healthcare.pain3.title': '合规报告负担',
  'healthcare.pain3.challenge': '手动追踪法规要求耗时且容易出错',
  'healthcare.pain3.solution': '我们的咨询方法：自动化合规监控和报告系统，内建审计追踪和即时警报',
  'healthcare.pain3.result': '合规报告时间减少80%，审计准备改善100%',

  // Education
  'education.desc': '为教育机构提供现代化、互动式的数字解决方案',
  'education.pain1.title': '系统断裂',
  'education.pain1.challenge': '学生信息、成绩和沟通分散在多个平台上',
  'education.pain1.solution': '我们的咨询方法：整合学习管理系统(LMS)，统一学生数据、成绩和家长沟通',
  'education.pain1.result': '行政效率提高65%，家长参与度提升45%',
  'education.pain2.title': '有限的参与追踪',
  'education.pain2.challenge': '难以监控学生进度和识别需要支持的学生',
  'education.pain2.solution': '我们的咨询方法：实施分析驱动的追踪系统，提供即时洞察学生表现和参与度',
  'education.pain2.result': '早期干预改善55%，学生成果提升35%',
  'education.pain3.title': '手动费用收集',
  'education.pain3.challenge': '纸本发票和现金处理导致延迟和对账问题',
  'education.pain3.solution': '我们的咨询方法：数字支付系统，具有自动发票、提醒和在线支付选项',
  'education.pain3.result': '准时付款增加75%，行政成本降低40%',

  // Retail & Service
  'retail.desc': '通过智能自动化推动零售和服务业的增长',
  'retail.pain1.title': '库存差异',
  'retail.pain1.challenge': '手动库存追踪导致缺货、过度库存和收入损失',
  'retail.pain1.solution': '我们的咨询方法：即时库存管理系统，具有自动补货和预测分析',
  'retail.pain1.result': '缺货减少60%，库存成本降低35%',
  'retail.pain2.title': '分散的客户数据',
  'retail.pain2.challenge': '客户信息分散在销售点、在线和忠诚度计划中',
  'retail.pain2.solution': '我们的咨询方法：统一的CRM系统，整合所有接触点，实现个性化营销和服务',
  'retail.pain2.result': '客户保留率提高50%，重复购买增加40%',
  'retail.pain3.title': '手动流程',
  'retail.pain3.challenge': '从订单处理到报告的手动任务消耗宝贵时间',
  'retail.pain3.solution': '我们的咨询方法：端到端流程自动化，从订单到履行到财务报告',
  'retail.pain3.result': '处理时间减少70%，运营效率提升55%',

  // Process Section
  'process.title': '我们的咨询流程',
  'process.subtitle': '以客户为中心的方法，确保完美契合',
  'process.step1.title': '发现',
  'process.step1.desc': '了解您的业务需求和挑战',
  'process.step2.title': '设计',
  'process.step2.desc': '打造直观、可扩展的架构',
  'process.step3.title': '开发',
  'process.step3.desc': '使用最新技术构建可靠和高性能的解决方案',
  'process.step4.title': '测试',
  'process.step4.desc': '严格的质量保证，提供无错误、高性能的产品',

  // Benefits Section
  'benefits.title': '为什么选择我们',
  'benefits.subtitle': '您成功的优势',
  'benefits.affordable.title': '可负担的IT预算',
  'benefits.affordable.desc': '我们的解决方案通过优化工作流程和减少手动工作，最大限度地降低长期成本。',
  'benefits.efficiency.title': '提升效率',
  'benefits.efficiency.desc': '整合先进技术以自动化流程并提高服务质量。',
  'benefits.specialized.title': '行业专业顾问',
  'benefits.specialized.desc': '无论是医疗保健的安全数据处理、教育的互动工具，还是零售的智能系统，我们都能根据您行业的需求进行定制。',
  'benefits.expertise.title': '经验证的专业知识',
  'benefits.expertise.desc': '凭借多年服务香港充满活力市场的经验，我们提供可靠的结果。',
  'benefits.roi.title': '可衡量的投资回报率',
  'benefits.roi.desc': '我们的咨询方法专注于可量化的成果——效率提升40-80%，成本降低35-70%。',
  'benefits.partnership.title': '端到端合作伙伴关系',
  'benefits.partnership.desc': '从初步咨询到实施后支持，我们在每一步都与您同在。',

  // Contact Section
  'contact.title': '联系我们',
  'contact.subtitle': '准备好转型您的业务了吗？',
  'contact.description': '今天就联系我们，获取免费咨询。让我们共同构建推动您成功的解决方案！',
  'contact.form.name': '您的姓名',
  'contact.form.email': '您的电子邮件',
  'contact.form.company': '公司名称',
  'contact.form.industry': '行业',
  'contact.form.industryPlaceholder': '选择您的行业',
  'contact.form.healthcare': '医疗保健',
  'contact.form.education': '教育',
  'contact.form.retail': '零售与服务',
  'contact.form.other': '其他',
  'contact.form.message': '您的消息',
  'contact.form.messagePlaceholder': '告诉我们您的需求...',
  'contact.form.submit': '发送消息',
  'contact.form.sending': '发送中...',
  'contact.form.success': '感谢您！我们会尽快与您联系。',
  'contact.form.error': '发送失败。请稍后再试。',
  'contact.email': '发送电子邮件',
  'contact.directEmail': '或直接发送电子邮件至',

  // Footer
  'footer.tagline': '通过智能自动化转型您的运营',
  'footer.quickLinks': '快速链接',
  'footer.newsletter': '订阅电子报',
  'footer.newsletterDesc': '获取最新的自动化趋势和行业洞察',
  'footer.emailPlaceholder': '输入您的电子邮件',
  'footer.subscribe': '订阅',
  'footer.subscribing': '订阅中...',
  'footer.subscribeSuccess': '感谢订阅！',
  'footer.subscribeError': '订阅失败。请稍后再试。',
  'footer.rights': '版权所有',
  'footer.poweredBy': '由 Readdy 提供支持',
};